// StageActivationRouter.tsx

import * as React from "react";
import { AppId } from "../../../../app/appTypes";
import { AddStageDocument } from "./AddStageDocument";
import { DocumentTypes } from "../../../documents/documentTypes";
import { ProcessStageOverview } from "../validationProcessApi";

interface AddStageDocumentRouterProps {
    open: boolean;
    stage: ProcessStageOverview | null;
    docCode: string;
    processId: AppId | null;
    structureId: number;
    processName?: string;
    processNumber?: string;
    deviceId?: string;
    onSuccess: (stage: any) => void;
    onCancel: () => void;
}

const DOC_CONFIG: Record<
    string,
    {
        documentType: DocumentTypes;
        titleL10nId?: string;
        defaultTitle: string;
    }
> = {
    DQ: {
        documentType: "DQ",
        titleL10nId: "process-dq-stage-activation-title",
        defaultTitle: "Dokument DQ (Design Qualification)",
    },
    RA: {
        documentType: "RA",
        titleL10nId: "process-ra-stage-activation-title",
        defaultTitle: "Dokument RA (Risk Assessment)",
    },
    AC: {
        documentType: "AC",
        titleL10nId: "process-ac-stage-activation-title",
        defaultTitle: "Dokument AC (Acceptance Criteria)",
    },
    IQ: {
        documentType: "IQ",
        titleL10nId: "process-iq-stage-activation-title",
        defaultTitle: "Dokument IQ (Installation Qualification)",
    },
    OQ: {
        documentType: "OQ",
        titleL10nId: "process-oq-stage-activation-title",
        defaultTitle: "Dokument OQ (Operational Qualification)",
    },
    PQ: {
        documentType: "PQ",
        titleL10nId: "process-pq-stage-activation-title",
        defaultTitle: "Dokument PQ (Performance Qualification)",
    },
    ACS: {
        documentType: "ACS",
        titleL10nId: "process-acs-stage-activation-title",
        defaultTitle: "Dokument ACS (Analiza krytyczności systemu)",
    },
    ACM: {
        documentType: "ACM",
        titleL10nId: "process-acm-stage-activation-title",
        defaultTitle: "Dokument ACM (Analiza krytyczności modułów)",
    },
    ACP: {
        documentType: "ACP",
        titleL10nId: "process-acp-stage-activation-title",
        defaultTitle: "Dokument ACP (Analiza krytyczności procesów)",
    },
    ACF: {
        documentType: "ACF",
        titleL10nId: "process-acf-stage-activation-title",
        defaultTitle: "Dokument ACF (Analiza krytyczności funkcjonalności)",
    },
    VMP: {
        documentType: "VMP",
        titleL10nId: "process-vmp-stage-activation-title",
        defaultTitle: "Dokument VMP (Validation Master Plan)",
    },
};

export const AddStageDocumentRouter: React.FC<AddStageDocumentRouterProps> = ({
    open,
    stage,
    docCode,
    processId,
    structureId,
    processName,
    processNumber,
    deviceId,
    onSuccess,
    onCancel,
}) => {
    if (!open || !stage) return null;

    const cfg = DOC_CONFIG[docCode];
    if (cfg) {
        return (
            <AddStageDocument
                open={open}
                processId={processId}
                structureId={structureId}
                processName={processName}
                processNumber={processNumber}
                deviceId={deviceId}
                stageId={stage.id}
                documentType={cfg.documentType}
                titleL10nId={cfg.titleL10nId}
                defaultTitle={cfg.defaultTitle}
                onSuccess={onSuccess}
                onCancel={onCancel}
            />
        );
    }
    else {
        return null;
    }
};
